;(function() {
  'use strict'

  Service.$inject = ["glDialog"];
  angular.module('app.core').service('relocateDialogService', Service)

  /* @ngInject */
  function Service(glDialog) {
    var self = this

    self.show = show

    function show(options) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="relocate-dialog__dialog">',
          '<relocate-dialog ',
            'direction="{{ direction }}"',
            'collection="collection"',
            'selected-items="selectedItems"',
            'get-label="getLabel($item)"',
            'on-done="dialog.close($amount)"',
            'on-cancel="dialog.cancel()"',
          '/>',
        '</gl-dialog>',
      ]
      return glDialog.show({
        template: template.join(''),
        clickOutsideToClose: false,
        escapeToClose: true,
        locals: {
          direction: options.direction,
          collection: options.collection,
          selectedItems: options.selectedItems,
          getLabel: options.getLabel,
        },
      })
    }
  }
})()
